import {action, observable, runInAction, makeObservable} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {ProfileApi} from '../data';
import {AbstractSecureStorage, SecureStorage} from '@yosmanyga/abstract-secure-storage'
import {Dispatcher} from "@yosmanyga/base";

class ProfileController {
    loaded: boolean;
    version: string = '';

    constructor(
        private dispatcher: Dispatcher,
        private profileApi: ProfileApi,
        private secureStorage: SecureStorage,
    ) {
        this.loaded = false;

        this.dispatcher.register(
            'play_input_executed',
            this.listenToPlayInputExecuted
        );
        
        makeObservable(this, {
            loaded: observable,
            version: observable,
            load: action,
        });
    }

    load = async () => {
        let version = await this.secureStorage.get('version')

        if (!version) {
            const profile = await this.profileApi.gatherProfile();

            version = profile.version;
        }

        await this.secureStorage.set('version', version)

        runInAction(() => {
            this.version = version as string;
            this.loaded = true;
        });
    };

    isBasic(): boolean {
        return this.version === 'basic';
    }

    listenToPlayInputExecuted = async ({version}: { version: string }) => {
        this.version = version;

        await this.secureStorage.set('version', version);
    };
}

decorate(injectable(), ProfileController);
decorate(inject(Dispatcher), ProfileController, 0);
decorate(inject(ProfileApi), ProfileController, 1);
decorate(inject(AbstractSecureStorage), ProfileController, 2)

export {ProfileController};
